<div class="container" *spaceContext="'main'">
  <div class="body">
    <h1 class="px-8">Stitch.ai</h1>
    <router-outlet />
  </div>
</div>
